import { render, staticRenderFns } from "./DialogAuthentication.vue?vue&type=template&id=53be15dc&scoped=true&"
import script from "./DialogAuthentication.vue?vue&type=script&lang=js&"
export * from "./DialogAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./DialogAuthentication.vue?vue&type=style&index=0&id=53be15dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53be15dc",
  null
  
)

export default component.exports